import lt101 from "./t10.webp";
import lt102 from "./t10(1).webp";

const lt10 = [lt101, lt102];

export default lt10;
